import styled from 'styled-components'

export const SuffixWrap = styled.div`
  display: flex;
`
export const Suffix = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 12px;
    color: #555;
    background-color: #eee;
    height: 40px;
    border: 1px solid #c7c9c7;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    box-sizing: border-box;
    margin-left: 1px;
    color: rgba(0, 0, 0, 0.38);
`
